import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function EnableSmartNudges() {
    return (
        <OnboardingBody
            title='Smart nudges: AI-generated conversation starters'
            statusText='New: Engagement bar'
        >
            <p>
                Assist visitors in starting their experience by showcasing unique smart nudges on
                each page, generated entirely by Nutshell AI. Smart nudges are based on the content
                found on each page of your site.
            </p>
        </OnboardingBody>
    );
}
